<template>
	<div class="search-bar">
		<input class="search-bar__input" type="text" :placeholder="placeholder" @keyup="$emit('keyup', $event)" @input="$emit('input', $event.target.value, $event)" :value="value" />
		<svgicon class="search-bar__icon" icon="magnify" />
	</div>
</template>

<script>
	export default {
		props: ['placeholder', 'value']
	}
</script>

<style lang="scss">
	.search-bar {
		position: relative;

		&__input {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			background-color: transparent;
			padding-left: 70px;

			&::placeholder {
				color: #a7a7a7;
			}
		}

		&__icon {
			position: absolute;
			left: 30px;
			top: 22px;
			width: 16px;
			height: 16px;
			fill: #a7a7a7;
			pointer-events: none;
		}
	}
</style>